import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import axios from "axios";
import LineChart from "../LineChart";
import { scrollToSection } from "../helpers/links";

const ExpensesPieChart = ({ expensesPath, month, useMonth }) => {
  const [data, setData] = useState(null);

  const fetchData = () => {
    let url = `${expensesPath}.json?kind=last_6_months`;
    url = useMonth ? `${url}&month=${month}` : url;
    axios
      .get(url, {
        headers: ReactOnRails.authenticityHeaders({}),
      })
      .then((response) => {
        const { data } = response.data;
        setData(data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    scrollToSection("line_expenses_chart");
  }, [data]);

  if (!data) {
    return null;
  }

  return (
    <div
      className="px-2 flex flex-col items-center justify-center mt-4"
      id="line_expenses_chart"
    >
      <div
        className={`max-w-xl w-full ${
          data.length === 0
            ? ""
            : "p-4 bg-white dark:bg-gray-800 rounded-lg card-shadow"
        }`}
      >
        <LineChart data={data} title={"Expenses for the last 6 months"} />
      </div>
    </div>
  );
};

ExpensesPieChart.propTypes = {
  expensesPath: PropTypes.string.isRequired,
  month: PropTypes.string,
  useMonth: PropTypes.bool,
};

export default ExpensesPieChart;
